
import { Component, Prop, Vue } from 'vue-property-decorator';
import api from '@/api';
import moment from 'moment';
import { Route } from 'vue-router';
import Swal from 'sweetalert2';
import ItemForm from './Form.vue';

const { banner } = api;

@Component({
  components: { ItemForm },
})
export default class BannerEdit extends Vue {
  @Prop({}) private id!: string;

  private form = {
    name: null,
    startTime: null,
    endTime: null,
    isEnabled: null,
    wideImageUrl: null,
    narrowImageUrl: null,
    url: null,
  };

  private loading: boolean = false;

  private async submit(form: any) {
    if (form) {
      this.loading = true;
      const { status } = await banner.update(this.id, form);
      this.loading = false;
      if (status === 1) {
        await Swal.fire({ icon: 'success', title: '修改成功' });
        await this.$router.back();
      }
    }
  }

  private setForm(data: any) {
    this.form = data;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: (vm: BannerEdit) => void) => void,
  ) {
    const { id } = to.params;
    const { data } = await banner.get(id);
    data.startTime = moment(data.startTime).format('YYYY-MM-DD HH:mm');
    data.endTime = moment(data.endTime).format('YYYY-MM-DD HH:mm');
    await next(async (vm) => {
      vm.setForm(data);
    });
  }
}
